module.exports = __webpack_public_path__ + "img/main_architecture_image03_en.d8d0c597.png";